import { Config } from 'react-player/lazy';
import { getVimeoThumbnailUrl } from 'modules/vimeoInfo';
import { IVideo, VideoPlatformType } from './types';

// quick helper should be deprecated when razer views has been removed.
export function getVideoPlatformFromUrl(url: string) {
    if (url.includes('vimeo')) {
        return 'Vimeo';
    }

    return 'YouTube';
}

export async function getVideoThumbnailById(id: string | number, platform: VideoPlatformType) {
    if (platform === 'Vimeo') {
        return getVimeoThumbnailUrl(id);
    }

    return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
}

// get start time in seconds from the video url
export function getStartTimeFromVideoUrl(video: IVideo['url']) {
    const { hash } = new URL(video);

    if (!hash) return null;

    const match = hash.match(/t=(\d+(?:m|s))(\d+s)?/);

    if (!match) return null;

    const [startTimeMatch, minutesOrSecondsMatch, secondsMatch] = match;

    const minutesOrSecondsMatchInSeconds = minutesOrSecondsMatch.match(/\d+m/)
        ? parseInt(minutesOrSecondsMatch) * 60
        : parseInt(minutesOrSecondsMatch);
    const secondsMatchInSeconds = secondsMatch ? parseInt(secondsMatch) : 0;
    const totalTimeInSeconds = minutesOrSecondsMatchInSeconds + secondsMatchInSeconds;

    return totalTimeInSeconds;
}

// Our predefined video configs for vimeo/youtube
export function getVideoConfig(video: IVideo): Config | null {
    const { searchParams } = new URL(video.url);
    const params = Array.from(searchParams.entries()).reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {});

    switch (video.platform) {
        case 'YouTube':
            return { youtube: { playerVars: { ...params } } };
        case 'Vimeo':
            return { vimeo: { playerOptions: { transparent: false, ...params } } };
        default:
            return null;
    }
}
